import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Box
} from '@mui/material';
import ContextReferenceSelector from '../../common/ContextReferenceSelector';

interface OutlineInstructionDialogProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  lang: string;
  projectId: string;
  title: string;
  confirmLabel: string;
  onConfirm: (instruction: string, fileIds?: string[]) => void;
  instructionLabel?: string;
  instructionPlaceholder?: string;
}

function OutlineInstructionDialog({
  open,
  onClose,
  loading,
  lang,
  projectId,
  title,
  confirmLabel,
  onConfirm,
  instructionLabel,
  instructionPlaceholder
}: OutlineInstructionDialogProps) {
  const [instruction, setInstruction] = useState('');
  const [fileIds, setFileIds] = useState<string[] | undefined>();

  const handleClose = () => {
    setInstruction('');
    setFileIds(undefined);
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(instruction, fileIds);
    handleClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      handleConfirm();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="outline-instruction-dialog-title"
      aria-describedby="outline-instruction-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="outline-instruction-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Box>
            <ContextReferenceSelector
              lang={lang}
              projectId={projectId}
              onFileIdsChange={setFileIds}
            />
          </Box>
          <TextField
            variant="filled"
            fullWidth
            multiline
            rows={4}
            label={instructionLabel || (lang === 'en' ? 'Instructions for AI (optional)' : 'AI 指令（可选）')}
            placeholder={instructionPlaceholder}
            value={instruction}
            onChange={(e) => setInstruction(e.target.value)}
            onKeyDown={handleKeyDown}
            margin="normal"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {lang === 'en' ? 'Cancel' : '取消'}
        </Button>
        <Button 
          onClick={handleConfirm} 
          color="primary" 
          variant="contained"
          disabled={loading}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default OutlineInstructionDialog; 